export default "__VITE_ASSET__BqGCpb8T__"